<!-- 안전리더십 > 과제설정 > 자유형식설정 팝업 -->
<template v-slot:default="{ isActive }">
  <v-dialog
    v-model="dialog"
    width="94rem"
    class="layer-popup"
    scrollable
  >
    <v-card>
      <!--content-->
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="pop-title">{{t('message.freeFormatSetting')}}</div>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click.stop="dialog = false"
        ></v-btn>
      </v-card-title>

      <!--content-->
      <v-card-text class="ty01">
        <div class="form-group col-ty">
          <!--form-row-->
          <div class="form-row ty05">
            <div class="txt-tit ty06">{{t('message.type')}}</div>
            <div class="row">
              <div class="txt">{{t('message.freeForm')}}</div>
            </div>
          </div>
          <!--form-row-->
          <div class="form-row ty05">
            <div class="txt-tit ty04">{{t('message.showGuideSection')}}</div>
            <div class="row">
              <v-switch v-model="viewInfo.guideYn" inset hide-details true-value="Y" false-value="N"/>
            </div>
          </div>
          <!--form-row-->
          <div class="form-row ty05">
            <div class="txt-tit ty04">{{t('message.enableUserFileUpload')}}</div>
            <div class="row">
              <v-switch v-model="viewInfo.fileYn" inset hide-details true-value="Y" false-value="N"/>
            </div>
          </div>
        </div>
        <div class="sort-group ty02">
          <div class="sort-row">
            <div class="wl">
              <div class="txt05">{{t('message.writeGuide')}}</div>
            </div>
          </div>
        </div>
        <div class="editor-ty">
          <quill-editor
            v-model:value="viewInfo.content"
            :options="editorOption"
            @change="onEditorChange($event)"
            @ready="onEditorReady"
          ></quill-editor>
        </div>
        <div class="form-group col-ty">
          <!--form-row-->
          <div class="form-row ty05">
            <div class="txt-tit ty04">{{t('message.addTrainingMaterial')}}</div>
            <div class="row">
              <FileUpload v-model="viewInfo.file" @change="onChangeImg"/>
            </div>
          </div>
        </div>
      </v-card-text>
      <!--버튼-->
      <v-card-actions class="d-flex justify-end pop-bottom-bg">
        <c-btn02 :btnText="t('message.cancel')" @click="dialog=false"/>
        <c-btn01 :btnText="t('message.save')" @click="onClickSave"/>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
  </v-dialog>
</template>

<script setup lang="ts">
import {ref, onMounted, watch} from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import {useForm} from "vee-validate";
import LeadershipService from "@/services/leadership.service";
import BoardService from "@/services/board.service";
import utils from "@/common/Utils";
import * as yup from "yup";
import { quillEditor,Quill } from 'vue3-quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import {useRoute} from "vue-router";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//validation schema
const schema = yup.object().shape({
  title: yup.string().required(() => t('message.requiredField')),
})
const { validate } = useForm({ validationSchema: schema })

//bind
const snackbar = ref(false)
const snackText = ref('')
const viewInfo:any = ref({})
const content = ref('')
const quillObject:any = ref(null)

//ui
const Size = Quill.import("attributors/style/size")
Size.whitelist = ["8px", "10px", "12px", "14px", "18px", "24px", "32px"] // 지원할 폰트 크기 리스트
Quill.register(Size, true)
const Font = Quill.import('formats/font')
Font.whitelist = ['noto-sans', 'noto-sans-kr', 'malgun-gothic', 'sans-serif']
Quill.register(Font, true)

//hook
onUpdated (() => {
  if (!dialog.value)
    return;

  getFreeBoard()
})

const getFreeBoard = async ()=>{
  try {
    let popupItems:any = storeRef.selectedContent.value
    if(utils.isEmpty(popupItems.idx)){
      snackText.value = t('message.noDataSelected')
      snackbar.value = true
      return
    }
    const response = await LeadershipService.getFreeBoard({contentIdx: popupItems.idx})
    viewInfo.value = response.result
    viewInfo.value.guideYn = viewInfo.value.guideYn?viewInfo.value.guideYn:'Y'
    viewInfo.value.fileYn = viewInfo.value.fileYn?viewInfo.value.fileYn:'Y'

    if (viewInfo.value.filePath) {
      const fileResponse = await fetch(utils.getBaseUrl("freeboard", viewInfo.value.filePath))
      if (!fileResponse.ok) {
        throw new Error(`download fail: ${fileResponse.statusText}`)
      }
      const blob = await fileResponse.blob()
      const imgFile = new File([blob], viewInfo.value.fileName, { type: blob.type })
      viewInfo.value.file = imgFile
    }
  }
  catch (error) {
    utils.log(error)
  }
}

const onClickSave = ()=>{
  let popupItems:any = storeRef.selectedContent.value
  const formData = new FormData();
  if(viewInfo.value.file)
    formData.append("file", viewInfo.value.file);
  formData.append("idx", !utils.isEmpty(viewInfo.value.idx)?viewInfo.value.idx:0);
  formData.append("leadershipIdx", viewInfo.value.leadershipIdx);
  formData.append("taskIdx", viewInfo.value.taskIdx);
  formData.append("contentIdx", viewInfo.value.contentIdx);
  formData.append("content", viewInfo.value.content);
  formData.append("guideYn", viewInfo.value.guideYn?viewInfo.value.guideYn:'N');
  formData.append("fileYn", viewInfo.value.fileYn?viewInfo.value.fileYn:'N');
  formData.append('companyIdx', localStorage.getItem('companyIdx'));

  LeadershipService.insertFreeBoard(formData).then(
    (response) => {
      if(response.success)
        dialog.value = false
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

function onEditorReady(editorInstance) {
  quillObject.value = editorInstance;
}
const onEditorChange = ({ quill, html, text }) => {
  content.value = html
}

const imageHandler=async()=>{
  const input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/*');
  input.click();

  input.onchange = async () => {
    const file = input.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append('companyIdx', localStorage.getItem('companyIdx'));

      try{
        const response = await BoardService.insertImage(formData)
        if (response.success) {
          const quill = quillObject.value
          const range = quill?.getSelection(true)
          if (range) {
            quill.insertEmbed(range.index, 'image', utils.getBaseUrl('editor', response.result.filePath))
            quill.setSelection(range.index + 1);
          }
        }
      }
      catch (error) {
        if(error.status == 403)
          utils.movePage('/login')
        else {
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    }
  }
}

const onChangeImg=(e: Event)=>{
  viewInfo.value.file = (e.target as HTMLInputElement).files[0];
}

const editorOption = {
  placeholder: t('message.enterText'),
  modules: {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{list: 'ordered'}, {list: 'bullet'}],
        [{script: 'sub'}, {script: 'super'}],
        [{indent: '-1'}, {indent: '+1'}],
        [{direction: 'rtl'}],
        [{size: ["8px", "10px", "12px", "14px", "18px", "24px", "32px"]}],
        [{color: []}, {background: []}],
        [{font: ["noto-sans", "noto-sans-kr", "malgun-gothic", "sans-serif"]}],
        [{align: []}],
        ['clean'],
        ['link', 'image', 'video']
      ],
      handlers: {
        image: imageHandler,
      },
    },
  }
}
</script>

<style lang="scss">
.ql-editor strong,
.ql-editor b {
  font-weight: bold !important;
}
.ql-editor em,
.ql-editor i {
  font-style: italic !important;
}
.ql-size-8px {
  font-size: 8px;
}
.ql-size-10px {
  font-size: 10px;
}
.ql-size-12px {
  font-size: 12px;
}
.ql-size-14px {
  font-size: 14px;
}
.ql-size-18px {
  font-size: 18px;
}
.ql-size-24px {
  font-size: 24px;
}
.ql-size-32px {
  font-size: 32px;
}
/* 각 항목 라벨 설정 */
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="8px"]::before {
  content: "8px";
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
  content: "12px";
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before {
  content: "24px";
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
  content: "32px";
}
/* 선택한 항목이 라벨에 표시될 수 있도록 설정 */
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="8px"]::before {
  content: "8px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="10px"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before {
  content: "12px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="24px"]::before {
  content: "24px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before {
  content: "32px";
}
.ql-font-noto-sans {
  font-family: Noto Sans, sans-serif;
}
.ql-font-noto-sans-kr {
  font-family: Noto Sans KR, sans-serif;
}
.ql-font-malgun-gothic {
  font-family: Malgun Gothic, sans-serif;
}
.ql-font-sans-serif {
  font-family: sans-serif, sans-serif;
}
/* 드롭다운 항목 텍스트 */
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="noto-sans"]::before {
  content: "Noto Sans";
  font-family: Noto Sans, sans-serif;
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="noto-sans-kr"]::before {
  content: "Noto Sans KR";
  font-family: "Noto Sans KR", sans-serif;
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="malgun-gothic"]::before {
  content: "Malgun Gothic";
  font-family: "Malgun Gothic", sans-serif;
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="sans-serif"]::before {
  content: "Sans Serif";
  font-family: sans-serif;
}

/* 선택된 라벨에 표시될 텍스트 */
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="noto-sans"]::before {
  content: "Noto Sans";
  font-family: Noto Sans, sans-serif;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="noto-sans-kr"]::before {
  content: "Noto Sans KR";
  font-family: "Noto Sans KR", sans-serif;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="malgun-gothic"]::before {
  content: "Malgun Gothic";
  font-family: "Malgun Gothic", sans-serif;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="sans-serif"]::before {
  content: "Sans Serif";
  font-family: sans-serif;
}
</style>
